import React from 'react';

import {
  Button,
  GoogleLogo,
  HStack,
  MicrosoftLogo,
  Text,
  VStack,
} from '@eluve/components';

export interface SocialLoginButtonsProps {
  isMicrosoftLoginEnabled?: boolean;
  onGoogleLogin: () => Promise<void>;
  onMicrosoftLogin: () => Promise<void>;
  disabled?: boolean;
}

export const SocialLoginButtons: React.FC<SocialLoginButtonsProps> = ({
  isMicrosoftLoginEnabled = true,
  onGoogleLogin,
  onMicrosoftLogin,
  disabled = false,
}) => {
  return (
    <VStack align="center">
      {/* Divider */}
      <HStack className="my-2">
        <div className="h-0.5 w-full bg-border-primary"></div>
        <Text
          size="md"
          color="primary"
          className="flex-1 whitespace-nowrap p-4"
        >
          or
        </Text>
        <div className="h-0.5 w-full bg-border-primary"></div>
      </HStack>

      {/* Social Login Buttons */}
      <VStack className={isMicrosoftLoginEnabled ? undefined : 'flex-row'}>
        <Button
          variant="outline"
          onClick={onGoogleLogin}
          className="flex w-full items-center justify-between px-4"
          disabled={disabled}
        >
          <div className="flex w-1/4 shrink-0 justify-end">
            <GoogleLogo className="size-5" />
          </div>
          <span className="w-3/4 flex-1 pl-3 text-left">
            Continue with Google
          </span>
        </Button>
        {isMicrosoftLoginEnabled && (
          <Button
            variant="outline"
            onClick={onMicrosoftLogin}
            className="flex w-full items-center justify-between px-4"
            disabled={disabled}
          >
            <div className="flex w-1/4 justify-end">
              <MicrosoftLogo className="size-5 shrink-0" />
            </div>
            <span className="w-3/4 flex-1 pl-3 text-left">
              Continue with Microsoft
            </span>
          </Button>
        )}
      </VStack>
    </VStack>
  );
};
